import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  "@keyframes fall-and-tumble": {
    "0%": {
      transform:
        "translate(var(--start-x), -80px) rotateZ(var(--start-rotate))",
    },
    "100%": {
      transform: "translate(var(--end-x), 46vh) rotateZ(var(--end-rotate))",
    },
  },
  container: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
    pointerEvents: "none",
    overflow: "hidden",
  },
  piece: {
    position: "absolute",
    top: 0,
    left: 0,
    width: theme.spacing.space8,
    height: theme.spacing.space12,
    borderRadius: 10,
    animationName: "$fall-and-tumble",
    animationTimingFunction: "linear",
    animationFillMode: "forwards",
  },
}));
